export const toCurrency = (value, currency_code = null, fractionDigits = 0) => {
  if (value === undefined) {
    return '';
  }
  if (isNaN(value)) {
    return value;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency_code || 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  return formatter.format(value / 100);
};

export const centsToCurrencyShorthand = (valueInCents, fractionDigits = 0) => {
  if (valueInCents === undefined) {
    return '';
  }
  const isNegative = valueInCents < 0;
  const valueInDollars = Math.abs(valueInCents) / 100;

  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'm' },
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return valueInDollars >= item.value;
    });

  const result = item
    ? (valueInDollars / item.value).toFixed(fractionDigits).replace(rx, '$1') +
      item.symbol
    : '0';

  return isNegative ? `-${result}` : result;
};
